import { Link } from "react-router-dom";
import { Facebook, Instagram, Youtube } from "lucide-react";
import { COMPANY, IMAGES, SOCIAL, STORY_PDF } from "../../data/content";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="bg-black text-neutral-400 text-xs border-t border-neutral-900"
  >
    <div className="py-12 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row justify-between items-center gap-6">
      <div className="text-center sm:text-left">
        <img src={IMAGES.logoBanner} alt="Legend Team" className="h-9 w-auto mb-3 mx-auto sm:mx-0" />
        <p className="font-bold text-neutral-200 uppercase">
          Legend Team Srl Sportiva Dilettantistica
        </p>
        <p className="mt-1">
          Strada Perticara, 13 &bull; 47866 Sant'Agata Feltria (Rimini)
        </p>
        <p className="mt-1 flex items-center justify-center sm:justify-start gap-3">
          <a href={`mailto:${COMPANY.email}`} className="hover:text-red-500">{COMPANY.email}</a>
          <a data-testid="footer-website" href={COMPANY.website} className="hover:text-red-500">{COMPANY.websiteLabel}</a>
          <a
            data-testid="footer-whatsapp"
            href={COMPANY.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-[#25D366] hover:text-white transition-colors"
          >
            <WhatsAppIcon className="w-3.5 h-3.5" /> {COMPANY.whatsapp}
          </a>
        </p>
      </div>
      <div className="flex space-x-6 mono-label text-xs uppercase">
        <a data-testid="footer-nav-storia" href="#capitolo-1" className="hover:text-red-500">Storia</a>
        <a data-testid="footer-nav-pdf" href={STORY_PDF} target="_blank" rel="noopener noreferrer" className="hover:text-red-500">Storia PDF</a>
        <a data-testid="footer-nav-club" href="#capitolo-3" className="hover:text-red-500">Club & Village</a>
        <a data-testid="footer-nav-academy" href="#capitolo-4" className="hover:text-red-500">Academy</a>
        <Link data-testid="footer-nav-gare" to="/gare" className="hover:text-red-500">Gare</Link>
        <Link data-testid="footer-nav-interviste" to="/interviste" className="hover:text-red-500">Interviste</Link>
      </div>
      <div className="flex items-center space-x-4">
        <a data-testid="social-instagram" href={SOCIAL.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram Legend Team" className="text-neutral-400 hover:text-red-500 transition-colors">
          <Instagram className="w-4 h-4" />
        </a>
        <a data-testid="social-facebook" href={SOCIAL.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook Legend Team" className="text-neutral-400 hover:text-red-500 transition-colors">
          <Facebook className="w-4 h-4" />
        </a>
        <a data-testid="social-youtube" href={SOCIAL.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube Legend Team" className="text-neutral-400 hover:text-red-500 transition-colors">
          <Youtube className="w-4 h-4" />
        </a>
      </div>
      <p>
        &copy; Legend Team Srl &bull; P.IVA {COMPANY.piva} &bull;{" "}
        <Link to="/segreteria" data-testid="footer-segreteria" className="hover:text-red-500">Accesso amministratori / Modifica sito</Link>
      </p>
    </div>
    <div data-testid="affiliazioni-strip" className="bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="text-neutral-700 text-center md:text-left">
          <span className="mono-label text-[11px] uppercase tracking-wider font-bold text-neutral-900 block">
            Affiliazioni &bull; Ente di promozione sportiva riconosciuto dal CONI
          </span>
          <span className="text-[11px]">
            MSP Italia &bull; Codice affiliazione CONI <strong data-testid="coni-code">{COMPANY.coniCodice}</strong> &bull; Sport Italia ASD &bull; Auto Moto Sport ASD Nazionale
          </span>
        </div>
        <img
          data-testid="affiliazioni-logos"
          src={COMPANY.entiImg}
          alt="Loghi MSP Italia (Ente di promozione sportiva riconosciuto dal CONI, cod. RN1 001 31), Sport Italia ASD e Auto Moto Sport ASD Nazionale"
          className="h-20 sm:h-28 w-auto object-contain"
          loading="lazy"
        />
      </div>
    </div>
  </footer>
);
